export default __webpack_public_path__ + "static/media/background-reunion.ec211020.jpg";